/**
 * @module ol/ImageState
 */

/**
 * @enum {number}
 */
export default {
  IDLE: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3
};

//# sourceMappingURL=ImageState.js.map